module.exports = __webpack_public_path__ + "media/images/plans/img_theme-wedding-18bffda19cbe39b73f6d61d63b18200b.jpg";